export const ExpeditionListMessageType = {
    PRINT_MESSAGE: 'print_expedition_list'
}

export const ExpeditionListMessageSeverity = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
}